import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ContractRefundPayment.GenerateRemittance.IRequest;
type Response = Api.Finance.ContractRefundPayment.GenerateRemittance.IResponse;
type Headers = Api.Finance.ContractRefundPayment.GenerateRemittance.IHeaders;
const url = '/api/Finance/ContractRefundPayment/GenerateRemittance/:contractRefundPaymentId';
export default async function contractRefundPaymentGenerateRemittanceApi({
  contractRefundPaymentId,
}: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { contractRefundPaymentId }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
